import { z } from 'zod';
import type { ApiSchemaClass, ApiSchemaDefinition } from './types';
import { atcRunColumnValueResponseSchema } from './common-responses';

const atcColumnValueConfigSchema = z.object({
  editorState: z.unknown(),
  model: z.unknown(),
  maxOutputTokens: z.number().nullable().optional(),
  topP: z.number().nullable().optional(),
  topK: z.number().nullable().optional(),
  temperature: z.number().nullable().optional(),
  frequencyPenalty: z.number().nullable().optional(),
  presencePenalty: z.number().nullable().optional(),
});

export const atcRunColumnValueBodyV20260601Schema = z.object({
  config: atcColumnValueConfigSchema,
  relIdentity: z.string(),
  colIdentity: z.string(),
  stableId: z.string(),
  completionId: z.string().nullable(),
  messages: z.array(z.unknown()),
});

/** Wire body for POST /api/v1/atc/column-values/run. Complex fields validated in handler. */
export type AtcRunColumnValueBody = {
  config: {
    editorState: unknown;
    model: unknown;
    maxOutputTokens?: number | null;
    topP?: number | null;
    topK?: number | null;
    temperature?: number | null;
    frequencyPenalty?: number | null;
    presencePenalty?: number | null;
  };
  relIdentity: string;
  colIdentity: string;
  stableId: string;
  completionId: string | null;
  messages: unknown[];
};

export class AtcRunColumnValueV20260601Schema implements ApiSchemaDefinition {
  static readonly version = 'atc-run-column-value-2026-06-01' as const;

  readonly name = AtcRunColumnValueV20260601Schema.version;
  readonly schema = atcRunColumnValueBodyV20260601Schema;
  readonly response = atcRunColumnValueResponseSchema;
}

export const ATC_API_SCHEMAS = [
  AtcRunColumnValueV20260601Schema,
] as const satisfies readonly ApiSchemaClass[];
